import { createElement } from "react";
/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/primitives';
const list = createElement(SVG, {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, createElement(Path, {
  d: "M4 4v1.5h16V4H4zm8 8.5h8V11h-8v1.5zM4 20h16v-1.5H4V20zm4-8c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2z"
}));
export default list;
//# sourceMappingURL=list.js.map